import React, {useEffect, useState} from 'react';
import {CommonServerSideParams} from '@/app/types/CommonServerSideParams';
import {OnlyBrowserPageProps} from '@/layouts/web/types/OnlyBrowserPageProps';
import {SSGPageProps} from '@/layouts/web/types/SSGPageProps';
import {
  getWebLayoutStaticProps,
} from '@/layouts/web/webLayoutSSG';
import WebLayout from '@/layouts/web/components/WebLayout';
import {createLogger} from '@/modules/core/logging/logger';
import {
  GetStaticProps, GetStaticPropsResult,
  NextPage,
} from 'next';
import {StaticPropsInput} from '@/app/types/StaticPropsInput';
import {getReactDivApiConfig} from '@/modules/core/reactDivAPI/utils/getApiConfig';
import deepmerge from 'deepmerge';
import PageHeader from "@/components/centralbrisbanedental/page/Header/Header";
import Annoucement from "@/components/centralbrisbanedental/Announcement";
import Topbar from "@/components/centralbrisbanedental/Topbar";
import NavBar from "@/components/centralbrisbanedental/NavBar/NavBar";
import CTABannerImageDescriptive
  from "@/components/centralbrisbanedental/CTABannerImageDescriptive/CTABannerImageDescriptive";
import CTABannerSplitTiles from "@/components/centralbrisbanedental/CTABannerSplitTiles/CTABannerSplitTiles";
import TwoColumnContent from "@/components/centralbrisbanedental/TwoColumnContent/TwoColumnContent";
import Footer from "@/components/centralbrisbanedental/Footer/Footer";


const fileLabel = 'pages/index';
const logger = createLogger({ // eslint-disable-line no-unused-vars,@typescript-eslint/no-unused-vars
  fileLabel,
});


let brisbaneDentistsContent: any = [
  {
    element: 'flexRow',
    classes: {
      display: "flex flex-col sm:flex-row",
      alignment: 'items-center'
    },
    children: [
      {
        element: 'flexCol',
        classes: {
          display: "flex-row sm:flex-col basis-full sm:basis-1/2",
          margin: "sm:px-8 sm:py-4"
        },
        children: [
          {
            element: 'image',
            imageProperties: {
              layout: 'fixed',
              alt: 'supertoothy character',
              src: '/static/images/heads/dr-vincent-wan.png.webp',
              height: 304,
              width: 214,
            },
            imageClasses: {
              textAlign: "center",
              margin: "mb-12"
            }
          },
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: 'BDSc (Hons) (Qld) The Brisbane CBD has been ' +
              'part of Dr Vincent Wan\'s life since he was 4 years old. ' +
              'Born in Hong Kong when it was still a British territory, Vincent’s family moved to Brisbane in 1985. ' +
              'He went to primary school at Warrigal Road State School in Eight Mile Plains, before transferring to…' +
              '<br /><br /><a class="bg-[#ff6600] block w-full py-3 px-5 text-center border border-transparent rounded-md shadow-md text-base font-medium !text-black no-underline sm:inline-block sm:w-auto"' +
              ' href="dr-vincent-wan">Read More</a>',
            classes: {
              margin: "mb-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            }
          },
        ]
      },
      {
        element: 'flexCol',
        classes: {
          display: "flex-row sm:flex-col basis-full sm:basis-1/2",
          margin: "sm:px-8 sm:py-4"
        },
        children: [
          {
            element: 'image',
            imageProperties: {
              layout: 'fixed',
              alt: 'supertoothy character',
              src: '/static/images/heads/dr-allen-wan-214x305.png.webp',
              height: 304,
              width: 214,
            },
            imageClasses: {
              textAlign: "center",
              margin: "mb-12"
            }
          },
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: 'BDSc (Hons) (Qld) Dr Allen Wan was born and ' +
              'bred in Brisbane.  His parents immigrated to Brisbane from Hong Kong a few years before he was born. ' +
              'He went to primary school at Warrigal Road State School in Eight Mile Plains and high school at Brisbane Grammar School on Spring Hill. ' +
              'At both schools, he…' +
              '<br /><br /><a class="bg-[#ff6600] block w-full py-3 px-5 text-center border border-transparent rounded-md shadow-md text-base font-medium !text-black no-underline sm:inline-block sm:w-auto"' +
              ' href="dr-allen-wan">Read More</a>',
            classes: {
              margin: "mb-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            }
          },
        ]
      },
    ]
  },
]
let brisbaneDentistsContentB: any = [
  {
    element: 'flexRow',
    classes: {
      display: "flex flex-col sm:flex-row",
      alignment: 'items-center justify-center'
    },
    children: [
      {
        element: 'flexCol',
        classes: {
          display: "flex-row sm:flex-col basis-full sm:basis-1/2",
          margin: "sm:px-8 sm:py-4"
        },
        children: [
          {
            element: 'image',
            imageProperties: {
              layout: 'fixed',
              alt: 'dr sima',
              src: '/static/images/team/dr-jenny-ahn.jpg',
              height: 521.5,
              width: 247,
            },
            imageClasses: {
              textAlign: "center",
              margin: "mb-12"
            },
            crop: true
          },
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: 'Dr Jenny Ahn is a compassionate and enthusiastic dentist with a strong interest in Preventive Dentistry,' +
              ' Orthodontics, and Cosmetic Dentistry. Jenny was born in South Korea and moved to Queensland in 2011, ' +
              'where she began to adapt to life in a new country and culture...' +
              '<br /><br /><a class="bg-[#ff6600] block w-full py-3 px-5 text-center border border-transparent rounded-md shadow-md text-base font-medium !text-black no-underline sm:inline-block sm:w-auto"' +
              ' href="dr-jenny-ahn">Read More</a>',
            classes: {
              margin: "mb-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            }
          },
        ]
      }
    ]
  },
]

/**
 * Only executed on the server side at build time.
 *
 * @return Props (as "SSGPageProps") that will be passed to the Page component, as props.
 *
 * @see https://github.com/vercel/next.js/discussions/10949#discussioncomment-6884
 * @see https://nextjs.org/docs/basic-features/data-fetching#getstaticprops-static-generation
 */
export const getStaticProps: GetStaticProps<SSGPageProps, CommonServerSideParams> = async (props: StaticPropsInput): Promise<GetStaticPropsResult<SSGPageProps>> => {
  const commonStaticProps: GetStaticPropsResult<SSGPageProps> = await getWebLayoutStaticProps()(props);
  if (process.env.NEXT_PUBLIC_APP_STAGE !== 'production') {
    logger.info('getStaticProps commonStaticProps', commonStaticProps); // eslint-disable-line no-console
  }

  if ('props' in commonStaticProps) {
    const config = getReactDivApiConfig();

    const [
      // Below is Web Module
      // currentShelledPage,
      // currentClientProjectSEOSettings,
      // currentShelledPageSeoSettings, // NOTE This is a dependency, should loop through these
      // currentClientProjectSEOSettings,
      // Above is Web Module
    ] = await Promise.all([
      // Below is Web Module
      // getShelledPageBySingularAPIID({config, slug: 'home'}),
      // getSystemShelledFieldsBySystemShellID({config, systemShellID: '630f756db23725aedbc16e7d'}),
      // getClientProjectContentBySystemShellID({
      //   config,
      //   clientID: commonStaticProps.props.reactDivClientID,
      //   projectID: commonStaticProps.props.reactDivClientProjectID,
      //   systemShellID: '630f756db23725aedbc16e7d',
      // }),
      // getBySingularAPIID({config, slug: "home"}),
      // Above is Web Module
    ]);

    return deepmerge(commonStaticProps, {
      props: {
        // Below is Web Module
        // currentShelledPage,
        // currentShelledPageSeoSettings,
        // currentClientProjectSEOSettings,
        // Above is Web Module
        builtAt: new Date().toISOString(),
      },
      // revalidate: regenerationDelay,
    });
    // return commonStaticProps;
  } else {
    return commonStaticProps;
  }

};
/**
 * SSG pages are first rendered by the server (during static bundling).
 * Then, they're rendered by the client, and gain additional props (defined in OnlyBrowserPageProps).
 * Because this last case is the most common (server bundle only happens during development stage), we consider it a default.
 * To represent this behaviour, we use the native Partial TS keyword to make all OnlyBrowserPageProps optional.
 *
 * Beware props in OnlyBrowserPageProps are not available on the server.
 */
type Props = {} & SSGPageProps<Partial<OnlyBrowserPageProps>>;

/**
 * Example of a public page.
 */
const BrisbaneDentistTeam: NextPage<Props> = (props): JSX.Element => {
  if (process.env.NEXT_PUBLIC_APP_STAGE !== 'production') {
    logger.info('Index props', props); // eslint-disable-line no-console
  }
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY)
    };

    handleScroll();

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  return (
    <>
      <WebLayout
        // reactDivClientID={}
        // reactDivClientProjectID={}
        hideFooter={false}
        pageSeoSettings={{
          seoTitle: 'Our Brisbane Dentist Team @ 289 Queen St',
          seoDescription: 'Central Brisbane Dental provide affordable dental treatment with regular promotions for new patients, as well as regular patient specials. Brisbane dentist Dr Vincent Wan has over 20 yrs experience. ',
          seoImage: '/static/images/tiles/sunbaking-toothy-teeth-whitening.png.webp',
          favicon: '/static/images/favicon/favicon-96.png',
        }}
      >
        <PageHeader
          title="Our Brisbane Dentists"
          background="bg-[#400068]"
          backgroundImage="/static/images/headers/life-cycle-header-overlay.png"
        />
        <TwoColumnContent
          content={brisbaneDentistsContent}
        />
        <TwoColumnContent
          content={brisbaneDentistsContentB}
        />
        <CTABannerSplitTiles
          dentist="vincent"
          heading="Did you know?"
          value="You can get 2 checkup and cleans a year for $0 or a very small out-of-pocket when you come and see us and use your health fund."
          buttonText="View terms and conditions"
          buttonDestination="/static/pdf/promotion-terms-and-conditions.pdf"
          hasInset={true}
          insetClasses={{
            display: 'hidden lg:block',
            position: 'absolute top-0 inset-x-0',
            height: 'h-1/2',
            dynamicBackground: '#400068'
          }}
          buttonClasses={{
            border: 'border border-transparent rounded-md',
            display: 'inline-flex',
            padding: 'px-5 py-3',
            dynamicBackground: '#17aaab',
            fontSize: 'text-base',
            fontWeight: 'medium',
            colour: 'text-black',
          }}
          classes={{
            position: 'relative',
            dynamicBackground: '#fff',
            padding: 'py-16'
          }}
        />
      </WebLayout>
    </>
  );
};

export default BrisbaneDentistTeam;

